export default __webpack_public_path__ + "85d7fe4c77d0a79792f6ecb79d0b16b7.png";